import React from 'react';
import PropTypes from 'prop-types';
import "./OoyalaVideoIndicator.scss";

const OoyalaVideoIndicator = ({widgetTypes = [], heroImageType}) => {
  if (heroImageType === "Video" || widgetTypes.find(val => val === "OoyalaEmbed")) {
    return (
      <div className="ooyala-video-indicator">
        <img className="ooyala-gradient" src="/img/thumbnail-gradient.svg"/>
        <img className="ooyala-indicator" src="/img/has-video-icon.svg"/>
      </div>
    )
  }

  return null;
}

OoyalaVideoIndicator.propTypes = {
  widgetTypes: PropTypes.array,
  heroImageType: PropTypes.string
}

export default OoyalaVideoIndicator;



// WEBPACK FOOTER //
// ./modules/News/components/OoyalaVideoIndicator.js